<!-- Navigation -->
<cipafacil-vertical-navigation #menuContainer class="dark bg-primary-900 text-white print:hidden"
    [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="verticalNavigation"
    [opened]="!isScreenSmall && !isCondominiumPage">
    <!-- Navigation header hook -->
    <ng-container cipafacilVerticalNavigationHeader>
        <!-- Logo -->
        <div [routerLink]="'/dashboard'" class="flex items-center h-20 p-6 cursor-pointer">
            <img class="w-30" src="assets/images/logo/logo-cipa-white.png" alt="">
        </div>
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container cipafacilVerticalNavigationFooter>
        <!-- User -->
        <user-menu></user-menu>
    </ng-container>
</cipafacil-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0 bg-gray-50 overflow-y-auto">

    <div class="fixed md:relative z-99 w-full h-full">

        <!-- Iphone Notch -->
        <div *ngIf="isIos" class="bg-card min-h-8 h-8 w-full -mb-1"></div>

        <!-- Header -->
        <div class="sticky top-0 flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 bg-gray-50 border-b print:hidden">
            <!-- Navigation toggle button -->
            <div class="flex items-center">
                <button *ngIf="!isCondominiumPage" class="mr-2" mat-icon-button (click)="toggleNavigation('mainNavigation')">
                    <mat-icon class="icon-size-5 text-primary-900" [svgIcon]="'awesome_regular_6:bars'"></mat-icon>
                </button>

                <img *ngIf="!menuContainer.opened" @fadeIn class="hidden md:block w-30 ml-2" src="assets/images/logo/logo-cipa.png" alt="">
            </div>
            <!-- Components -->
            <div class="flex items-center pl-2 ml-auto space-x-1 md:space-x-6">
                <checkin></checkin>
                <notifications></notifications>
                <user-menu [isCondominiumPage]="isCondominiumPage" *ngIf="isCondominiumPage"></user-menu>
                <div *ngIf="!isCondominiumPage" class="flex items-center">
                    <div class="flex flex-col mr-3 text-right">
                        <span class="text-xs">Edifício:</span>
                        <span
                            class="text-sm font-semibold uppercase text-primary-900">{{user?.condominium_active?.condominium.name}}</span>
                    </div>
                    <div (click)="toggleCondominium()" class="flex items-center cursor-pointer">
                        <mat-icon class="icon-size-5 text-primary-900" [svgIcon]="'awesome_light_6:rotate'"></mat-icon>
                    </div>
                </div>
                <!-- <button -->
                <!--     class="lg:hidden" -->
                <!--     mat-icon-button> -->
                <!--     <mat-icon class="icon-size-5" [svgIcon]="'awesome_solid:bars'"></mat-icon> -->
                <!-- </button> -->
            </div>
        </div>

        <!-- <quick-access *ngIf="hasCondominium" [position]="'top'"></quick-access> -->

        <!-- Content -->
        <div #content (scroll)="scroll()" class="flex flex-col flex-auto w-full h-full pb-20 md:pb-0 overflow-y-auto" [style.max-height]="getHeight() + 'px'">
            <carousel *ngIf="isDashboard && appService.hasPermission('notice_board_view')"></carousel>

            <router-outlet *ngIf="true"></router-outlet>
        </div>

    </div>
</div>
